import { WebServiceClient } from '../WebServiceClient'

export class GeoWebServiceClient extends WebServiceClient {
  private _token: string

  constructor (baseUrl: string, token: string | undefined, params: {[key: string]: string} | undefined) {
    const geoParams = {
      ...params,
      geoAreaId: '1'
    }
    super(baseUrl, geoParams)
    this._token = token === undefined ? '' : token
  }

  get token (): string {
    return this._token
  }

  set token (token: string) {
    this._token = token
  }
}
